export default __webpack_public_path__ + "static/media/ArrowRight.92f33415.svg";